import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';
import { IErknmAgreementApprove } from 'APIPackage/KnmModule/interfaces/IErknmAgreementApprove';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';
import { handleReactQuillDeltaValue } from 'functions/handleReactQuillDeltaValue';

import { IErknmFormAgreementApprove } from '../interfaces/IErknmFormAgreementApprove';

export const convertAgreementsApproveFormValuesToData = (
  approveInfo: IErknmFormAgreementApprove | undefined,
): IErknmAgreementApprove | null => {
  if (!approveInfo) return null;

  const {
    approved,
    note,
    numberDecision,
    dateDecision,
    whoMadeDecision,
    titleSigner,
    reasonForRefusal,
    attachment,
  } = approveInfo;

  return {
    approved: approved?.value || null,
    note: handleReactQuillDeltaValue(note || null),
    numberDecision: numberDecision || null,
    dateDecision: convertFormDateValueToKnmDataDate(dateDecision),
    whoMadeDecision: whoMadeDecision || null,
    titleSigner: titleSigner || null,
    reasonForRefusal: handleReactQuillDeltaValue(reasonForRefusal || null),
    attachment: convertKnmDocumentAttachmentsFormValuesToKnmData(attachment)?.pop() || null,
  };
};
